import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const AttachmentDetailsWrapper = styled.div`
  display: flex;
  flex-shrink: 0;
  width: 300px;
  padding-left: ${Spacing.S16};
  border-left: 1px solid ${Color.Grey150};
`

export const Footer = styled.footer`
  margin-top: ${Spacing.S16};
`
